import React, {useCallback, useEffect, useRef, useState} from 'react';
import range from 'lodash/range';
import moment from "moment";
import {Button, notification} from "antd";
import {Env} from "../Helpers/Env";
import {Images} from "../Helpers/Images";

export const useMergeState = initialState => {
    const [state, dispatch] = useState(initialState);

    const setState = (any) => {
        dispatch(prev => ({...prev, ...any}))
    }

    return [state, setState]
}

function countNumbers(v) {
    if (!v || !v.trim()) {
        return undefined;
    }
    let numb = v.match(/\d/g);
    if(numb) {
        return numb.join("");
    } else return ''

}
export const showNotification = () => {
    const key = 'notificationLocalKey';
    notification.open({
        duration: 8,
        description: <div>
            <div style={{marginBottom: 20, textAlign: 'center'}}>
                <img src={Images.logo} style={{height: 50}}/>
            </div>
            <div style={{marginBottom: 20}}>As vagas do Geração Emprego são exclusivas para o Estado de Rôndonia</div>

        </div>,
        key,
        placement: 'topRight'
    });
};


export const checkStateRestriction = (result) => {
    if (Env.state_restriction !== 'none') {
        if (result) {
            for(let i = 0; i < result?.address_components?.length; i++) {
                for(let j = 0; j < result.address_components[i].types.length; j++) {
                    if(result.address_components[i].types[j] === 'administrative_area_level_1') {
                        if(result.address_components[i].short_name === Env.state_restriction) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            }
            return false;
        }
    } else {
        return !!result;
    }
};

export const useGeolocation = () => {
     async function getGeoFromBrowser() {
        if (navigator.geolocation) {
            let latLng = {};
            let loc = '';
            navigator.geolocation.getCurrentPosition(item => {
                latLng = {latitude: item.coords.latitude, longitude: item.coords.longitude};
                let geocoder = new window.google.maps.Geocoder;
                geocoder.geocode({'location': {lat: item.coords.latitude, lng: item.coords.longitude }}, function(results, status) {
                    loc = results[0].formatted_address;
                    return {latLng, loc};
                });
            });
        }
    };
    return {getGeoFromBrowser}
}

export const usePaginate = () => {

    const paginateObj = {
        global: "",
        paginate: {
            page: 0,
            limit: 30,
            order: {
                field: "created_at",
                type: "ASC"
            }
        }
    }

    const search = (textSearch: string) => {
        paginateObj.global = textSearch;
    };

    const addField = (field: string, value: string|number) => {
        paginateObj[field] = value;
    };

    const page = (page: number) => {
        paginateObj.paginate.page = page;
    };

    const limit = (limit: number) => {
        paginateObj.paginate.limit = limit;
    };

    const order = (field: string, type: 'ASC|DESC') => {
        paginateObj.paginate.order.field = field;
        if(type) paginateObj.paginate.order.type = type;
    };

    return {page, limit, order, addField, search, paginateObj}
}

export const useVerifyShowPanel = (history, typePanel) => {
    // Passar props history and preferences.panel_profile
    let textPanel = typePanel === 'client' ? 'trabalhador' : 'contratante'

    const changePanelProfile = () => {
        if (Env.show_client_panel) {
            history.push(`/painel/${typePanel === 'client' ? 'prestador' : 'cliente'}`)

        } else {
            history.push(`/painel/${typePanel === 'client' ? 'prestador' : 'cliente/vagas'}`)
        }
    }

    const redirectToPanel = () => {
        if (Env.show_client_panel) {
            history.push(`/painel/${typePanel === 'client' ? 'cliente' : 'prestador'}`)

        } else {
            history.push(`/painel/${typePanel === 'client' ? 'cliente/vagas' : 'prestador'}`)
        }
    }

    const redirectToPanelByParam = (client) => {
        if(client) {
            if(Env.show_client_panel) {
                history.push(`/painel/cliente`)
            } else {
                history.push(`/painel/cliente/vagas`)
            }
        } else {
            history.push(`/painel/prestador`)
        }
    }

    return {changePanelProfile, textPanel, redirectToPanelByParam, redirectToPanel, typePanel}
}

export const useInterval = (callback, delay) => {
    const savedCallback = useRef();

    useEffect(
        () => {
            savedCallback.current = callback;
        },
        [callback]
    );


    useEffect(
        () => {
            const handler = (...args) => savedCallback.current(...args);

            if (delay !== null) {
                const id = setInterval(handler, delay);
                return () => clearInterval(id);
            }
        },
        [delay]
    );
};

/**
 *
 * @param totalRegs
 * @param regsPerRow
 * @returns {number[]}
 */
export const useNumberOfRows = (totalRegs: number, regsPerRow: number) => {
    return range(Math.ceil(totalRegs/regsPerRow));
};

export const useWindowSize = () => {
    function getSize(): { innerHeight: number, innerWidth: number, outerHeight: number, outerWidth: number, } {
        return {
            innerHeight: window.innerHeight,
            innerWidth: window.innerWidth,
            outerHeight: window.outerHeight,
            outerWidth: window.outerWidth,
        };
    }

    let [windowSize, setWindowSize] = useState(getSize());

    function handleResize() {
        setWindowSize(getSize());
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return {
        innerHeight: windowSize.innerHeight,
        innerWidth: windowSize.innerWidth,
        outerHeight: windowSize.outerHeight,
        outerWidth: windowSize.outerWidth,
    };
}

export const useToggle = (initialState) => {
    const [status, setStatus] = useState(initialState);

    function toggle() {
        setStatus(!status);
    }

    function reset() {
        setStatus(initialState);
    }

    return {status, toggle, reset};
}

export const useForceUpdate = () => {
    const [state, setState] = useState(Object.create(null));

    const forceUpdate = () => {
        setState(Object.create(null));
    }

    const onUpdate = (callback) => {
        if(callback) callback();
    }

    useEffect(() => {
        onUpdate();
    }, [state]);

    return {onUpdate, forceUpdate};
}

export const useFieldError = (form) => {

    const getFieldError = useCallback((fieldName) => {
        const filedError = form.getFieldError(fieldName);
        return filedError ?
            <label id="petition-title-error" className="error" htmlFor="petition-title">
                {filedError.join(', ')}
            </label>
            : null
    })

    const getFieldTextError = useCallback((fieldName) => {
        const filedError = form.getFieldError(fieldName);
        return filedError ? filedError.join(', ') : null
    })

    return {getFieldError, getFieldTextError}
}

export const useSelectValue = () => {
    const toObjectValue = (label, value) => {
        return {value: value, label: label}
    }

    return {toObjectValue}
}

export const eventVisible = () => {
    if(moment().diff(moment(Env.event_limit_date), 'days') <= 0) {

        return true
    } else {
        return false
    }
}

export const useValidationShorts = () => {
    const required = (message?: string) => {
        return {required: true, message: message || "Esse campo é obrigatório!"}
    };

    const passwordStrength  = () => {
        return {
            validator: (rule, value) => value.match(/^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/) !== null,
            message: <div style={{fontSize: 13, paddingTop: 10}}> - Mínimo de 8 caracteres <br/> - Deve conter números <br/> - Deve conter letras </div>
        }
    }

    const isValidDate  = () => {
        return {
            validator: (rule, value) => moment(value, 'DD/MM/YYYY').isValid() !== false,
            message: <div style={{fontSize: 14, paddingTop: 5}}> - Não é uma data válida </div>
        }
    }

    const minDate  = (date) => {
        return {
            validator: (rule, value) => date.diff(moment(value, 'DD/MM/YYYY'), 'day') <= 1,
            message: <div style={{fontSize: 14, paddingTop: 5}}> - Data mínima - {moment(date).format('DD/MM/YYYY')} </div>
        }
    }

    const minAge = (today) => {
        return {
            validator: (rule, value) => {
                return (
                    today.diff(moment(value, 'DD/MM/YYYY'), "years") > 15
                )
            },
            message: <div style={{fontSize: 14, paddingTop: 5}}>Idade não permitida</div>
        }
    }

    const strMin = (min, message?) => {
        return {
            type:'string',
            validator: (rule, value) => value.replace(/(<([^>]+)>)/ig,"").length > min,
            message: message
        }
    };

    const strMax = (max, message?) => {
        return {type:'string', max: max, message: message || "Esse campo é obrigatório!"}
    };

    const numMax = (max, message?) => {
        return {type:'number', transform(value) {return parseInt(value)}, max: max, message: message || "Esse campo é obrigatório!"}
    };

    const numMin = (min, message?) => {
        return {type:'number', transform(value) {return parseInt(value)}, min: min, message: message || "Esse campo é obrigatório!"}
    };

    const isEmail = (min, message?) => {
        return {type:'email', message: message || "Esse campo precisa ser um email válido!"}
    };

    const numMinWithMask = (min, message?) => {
        return {transform(value) {return countNumbers(value)}, min: min, message: message || "Esse campo é obrigatório!"}
    };

   const maxDaysDiffFrom = (startDate, maxDays = 60) => {
      return {
         validator: (rule, value) => {
            if (!startDate || !value) return true;

            const start = moment(startDate, 'DD/MM/YYYY', true);
            const end = moment(value, 'DD/MM/YYYY', true);

            if (!start.isValid() || !end.isValid()) return true;

            const diff = end.diff(start, 'days');
            if (diff < 0) return true;

            return diff <= maxDays;
         },
         message: <div style={{fontSize: 14, paddingTop: 5}}>
            O intervalo entre as datas não pode exceder {maxDays} dias
         </div>
      }
   }


   return {maxDaysDiffFrom, required,passwordStrength,isValidDate, minAge, numMinWithMask, strMin ,minDate, strMax, numMax, numMin, isEmail}
}

/**
 * Se o elemento ref está visível
 * @param ref
 * @param rootMargin
 * @returns {boolean}
 */
const useOnScreen = (ref, rootMargin = '0px') => {
    // State and setter for storing whether element is visible
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // Update our state when observer callback fires
                setIntersecting(entry.isIntersecting);
            },
            {
                rootMargin
            }
        );
        if (ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            observer.unobserve(ref.current);
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount

    return isIntersecting;
}


export function isUnder18(birthday) {
    const birthDate = moment(birthday);  // Cria um objeto moment com a data de nascimento
    const today = moment();             // Cria um objeto moment com a data atual

    const age = today.diff(birthDate, 'years');  // Calcula a diferença em anos

    return age < 18;  // Retorna true se a idade for menor que 18
}
